export const CurrencyDirection = {
  SourceToTarget: 'SourceToTarget',
  TargetToSource: 'TargetToSource'
} as const;

export type CurrencyDirection =
  typeof CurrencyDirection[keyof typeof CurrencyDirection];
